import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';

import { wcoxmlwebActions } from '../../../../redux/wcoxmlweb/actions';
import { getExportingStatus, getLoadingStatus } from '../../../../redux/wcoxmlweb/selectors';

export const ExportWcoXmlWebConfig = ({ companyData }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const exporting = useSelector(getExportingStatus);
  const loading = useSelector(getLoadingStatus);

  return (
    <Button
      disabled={loading}
      loading={exporting}
      onClick={() => dispatch(wcoxmlwebActions.exportWcoXmlConfig(companyData.company))}
      icon={<DownloadOutlined />}
    >
      {t('myCompanies.export')}
    </Button>
  );
};
